// pass one time class selector to base component
export function concatSelecor(
  classNames1: string,
  classNames2: string,
): string {
  return classNames1 + ' ' + classNames2
}
